function OrganizationMedia({ enquiry }) {
  return <div className="page">Coming Soon</div>;
}

export default OrganizationMedia;
